import React from 'react'

const PageNotFound = () => {
    return (
        <div>
            <div className="d-flex justify-content-center align-items-center full-height-background">
                <div className="col-10 p-sm-8 col-md-5 col-lg-5 col-xl-4" style={{ opacity: "0.90" }}>
                    <div className="mt-3 alert alert-success">
                        <div className="not-found-title text-center fw-bold fs-1 mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100">
                                <circle cx="50" cy="50" r="48" stroke="#dc3545" stroke-width="2" fill="none" />
                                <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="40" fill="#dc3545" text-anchor="middle" alignment-baseline="middle">404</text>
                            </svg>
                        </div>
                        <div className="not-found-message text-center">
                            Oops! The page you're looking for could not be found.
                        </div>
                        <p className='text-center'>It seems like the page has either been moved or no longer exists.</p>
                        <div className='text-center'><a href="/startPage" className="btn btn-success">Go Back to Home</a></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound